module.exports = __webpack_public_path__ + "static/media/PICK-UP.3256846b.svg";